import type { Entities } from '../../types';
import type { Action } from './project-access-action-creators';
import { FETCH_PROJECT_ACCESS_TYPES_SUCCESS } from './project-access-type';

export const defaultState: Entities = { accessTypes: [] };

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: Entities = defaultState, action: Action): Entities => {
	switch (action.type) {
		case FETCH_PROJECT_ACCESS_TYPES_SUCCESS:
			// @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
			return action.payload;
		default:
			return state;
	}
};
